import { generateMonochromePalette } from 'utils/highcharts.utils';

const getWorkspaceAccentPalette = count => {
  const fallbackPalette = generateMonochromePalette('#4be277', count);
  return fallbackPalette.map((color, index) => {
    const accentWeight = Math.max(28, 86 - index * 8);
    return `color-mix(in srgb, var(--workspace-accent) ${accentWeight}%, var(--workspace-surface) ${100 - accentWeight}%)`;
  });
};

export const getDonutChartOptions = ({ data, title, subtitle = '', useFormatter = false }) => {
  const total = data.reduce((sum, item) => sum + item.y, 0);
  const colors = getWorkspaceAccentPalette(data.length);

  // identify the largest slice
  const maxY = Math.max(...data.map(d => d.y));
  const preparedData = data.map(d => ({
    ...d,
    selected: d.y === maxY,
    sliced: d.y === maxY
  }));

  return {
    chart: {
      type: 'pie',
      height: 600,
      backgroundColor: 'transparent',
      plotBackgroundColor: 'transparent',
      plotBorderWidth: 0,
      spacing: [12, 12, 12, 12],
      style: {
        fontFamily: 'inherit',
        color: 'var(--workspace-text)'
      }
    },
    title: {
      text: title || `${total} Workers`,
      align: 'center',
      verticalAlign: 'middle',
      style: {
        color: 'var(--workspace-text)',
        fontSize: '18px',
        fontWeight: '700'
      }
    },
    colors,
    subtitle: subtitle
      ? {
          text: subtitle,
          align: 'center',
          verticalAlign: 'middle',
          y: 30,
          style: {
            color: 'var(--workspace-text-muted)'
          }
        }
      : undefined,
    legend: {
      itemStyle: {
        color: 'var(--workspace-text-muted)'
      },
      itemHoverStyle: {
        color: 'var(--workspace-text)'
      }
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        innerSize: '60%',
        borderColor: 'var(--workspace-surface)',
        borderWidth: 3,
        slicedOffset: 8,
        dataLabels: {
          enabled: true,
          connectorColor: 'var(--workspace-border)',
          connectorWidth: 1,
          color: 'var(--workspace-text-muted)',
          ...(useFormatter
            ? {
                formatter: function () {
                  const { name, y, max } = this.point;
                  return `<b>${y}/${max}</b> ${name}`;
                }
              }
            : {
                format: '{point.name} ({point.y})'
              }),
          style: {
            color: 'var(--workspace-text-muted)',
            fontSize: '12px',
            fontWeight: '600',
            textOutline: 'none'
          }
        }
      }
    },
    tooltip: {
      backgroundColor: 'var(--workspace-surface)',
      borderColor: 'var(--workspace-border)',
      borderRadius: 6,
      shadow: false,
      style: {
        color: 'var(--workspace-text)',
        fontSize: '12px'
      },
      pointFormat: useFormatter
        ? '<b>{point.y}</b> of <b>{point.max}</b> in {point.name}'
        : '{point.name}: <b>{point.y}</b>'
    },
    series: [
      {
        name: title || 'Workers',
        colorByPoint: true,
        data: preparedData
      }
    ]
  };
};
